import { NextButtonField } from '../checkInReserve/nextButtonField';
import { EntryLoanerCarField } from './entryUseLoanerCar';
import './loanerCarEntryStyle.css';

interface CheckInUseLoanerCarProps {
  props: {
    loanerCarInfoState: {
      state: {
        loanerCarSelect: number;
        carRequestText: string;
      };
      setState: {
        loanerCarSelect: (select: number) => void;
        carRequestText: (text: string) => void;
      };
      list: {
        loanerCarSelect: string[];
      };
      error: { carRequestText: string };
    };
    approveCheck: boolean;
    onChangeCheck: () => void;
  };
  disabled: boolean;
  onNext: () => void;
}
export const CheckInUseLoanerCar = ({
  props: { loanerCarInfoState, approveCheck, onChangeCheck },
  disabled,
  onNext,
}: CheckInUseLoanerCarProps) => {
  return (
    <div className={'check-in-loaner-car-field'}>
      <EntryLoanerCarField
        check={approveCheck}
        onChangeCheck={onChangeCheck}
        loanerCarInfo={loanerCarInfoState}
      />
      <NextButtonField disable={disabled} onClick={onNext} />
    </div>
  );
};
